import { Select } from 'antd';
import React, { useEffect } from 'react';

import { addChangeListener } from 'stores/DynamicProperties/changeListeners';
import { type IDynamicProperty } from 'stores/DynamicProperties/IDynamicProperty';
import { useForceUpdate } from 'utils/Hooks';

import { ScalarContainer } from './ScalarContainer';

export interface SelectInputProps {
  disabled?: boolean;
  options: ReadonlyArray<string>;
  property: IDynamicProperty<any>;
}

// Not an observer, deliberately. Nothing read during render is observable: a
// leaf DynamicProperty never calls becomeObservable, and the only path that
// would make one observable - DynamicGroup.enableState - has no callers.
// Re-rendering comes entirely from the subscription below.
function SelectInput({ property, disabled, options }: SelectInputProps) {
  const forceUpdate = useForceUpdate();
  useEffect(
    () => addChangeListener(property, forceUpdate),
    [property, forceUpdate]
  );

  // antd hands over the chosen value rather than an event. It is typed `any`
  // because Select is used without its value generic here.
  const handleChange = (value: any) => {
    property.set(value);
  };

  return (
    <ScalarContainer size="small">
      <Select
        style={{ width: '100%' }}
        value={property.value}
        onChange={handleChange}
        disabled={disabled}
      >
        {options.map((item) => (
          <Select.Option key={item} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </ScalarContainer>
  );
}

export default SelectInput;
